import { isArray } from "lodash"
import { isDate } from "../utils/obejct-diff"
import * as moment from 'moment'

export enum FilterType {
    EQUALITY, DATE, 
}

interface IFilterCheckExtraFiled {
    key:string
    value:string
    type:string
}

export abstract class Filter {

    // private sortOrder = FilterSort.UNSORTED
    
    constructor(
        public filterName: string,
        public filterField: string,
        public filterValue: any,
        public filterCheckExtraFiled?:IFilterCheckExtraFiled[] |  undefined
        // sort?: FilterSort
    ) {
        // if (sort) this.sortOrder = sort
    }

    abstract filterFn(record: any): boolean 
    abstract filterExtraFieldFn(record: any): boolean 
}

export class FilterEqual extends Filter {
    
    constructor(
        filterName: string,
        filterField: string, filterValue: any, 
        filterCheckExtraFiled?:IFilterCheckExtraFiled | undefined) {
        super(filterName, filterField, filterValue)
    }

    filterFn(record: any): boolean {
        // if (!Object.keys(record).includes(this.filterField)) return false
        // return record[`${this.filterField}`] == this.filterValue
        if (!Object.keys(record).includes(this.filterField)) return false
        else{
            if(isArray(record[`${this.filterField}`])){
                if(record[`${this.filterField}`].length==0)
                    return false
                else{
                    return record[`${this.filterField}`].includes(this.filterValue)
                }
            }else
            return record[`${this.filterField}`] == this.filterValue
        }
    }

    filterExtraFieldFn(record: any): boolean {
        let included = false
        this.filterCheckExtraFiled?.forEach( (filter) => {
            if (!Object.keys(record).includes(filter.key)) return included = false
            else{
                if(filter.type == 'array'){

                    if(!record[`${filter.key}`])
                    return included = false
                    else{
                        if(record[`${filter.key}`].includes(filter.value))
                        return included = record[`${filter.key}`].includes(filter.value)
                    }
                }else
                return included = record[`${filter.key}`] == filter.value
            }
                
        })
        return included
    }
}

export enum DateFilterOption {
    BEFORE, AFTER, BETWEEN, NOTIN
}

export class DateFilter extends Filter {
    
    dateFilterOption = DateFilterOption.BEFORE

    constructor(
        filterName: string,
        filterField: string, 
        filterOption: DateFilterOption,
        public filterValue: {startDate?: Date, endDate?: Date, baseValue: Date},
    ) {
        super(filterName, filterField, filterValue)
        if (filterOption) this.dateFilterOption = filterOption
    }

    filterFn(record: any): boolean {
        if (!Object.keys(record).includes(this.filterField)) return false
        if (!isDate(record[`${this.filterField}`])) return false
        switch(this.dateFilterOption) {
            case(DateFilterOption.AFTER): {
                return record[`${this.filterField}`] >= this.filterValue.baseValue
            }
            case(DateFilterOption.BEFORE): {
                return record[`${this.filterField}`] <= this.filterValue.baseValue
            }
            case(DateFilterOption.BETWEEN): {
                if (!this.filterValue.startDate || !this.filterValue.endDate) return false
                const start = moment(this.filterValue.startDate)
                const end = moment(this.filterValue.endDate)
                return moment(record[`${this.filterField}`]).isBetween(start, end)
            }
            case (DateFilterOption.NOTIN): {
                if (!this.filterValue.startDate || !this.filterValue.endDate) return false
                const start = moment(this.filterValue.startDate)
                const end = moment(this.filterValue.endDate)
                // const dateBetween = moment(this.filterValue.baseValue)
                return !moment(record[`${this.filterField}`]).isBetween(start, end)
            }
        }
    }


    filterExtraFieldFn(record: any): boolean {
        let included = false
        return included
    }
}

/**
 * 
 * @param records 
 *  any Objects 
 * @param filter 
 *  List of filters, individual lists represent 
 *  OR filters list combined represent AND
 * @returns 
 *  records or empty array after applying filters 
 */
export const filterObjects = (records: any[], filter: Array<Filter[]>) => {
    const filtered = new Set<any>()

    records.forEach((record) => {
        let and = true
        filter.forEach((orFilter, index) => {
            let or = false
            orFilter.forEach((f, index) => {
                const filterFn = f.filterFn(record)
                if (filterFn) or = true

                if(f.filterCheckExtraFiled){
                    if(f.filterExtraFieldFn(record) || filterFn) or = true
                }
            })
            if (!or) {
                and = false
                return 
            }
        })
        if (and) filtered.add(record)
    })

    return [...filtered.values()]
}